import { useInfiniteQuery } from "@tanstack/react-query";

import { useApiRequest } from "@hooks/use-api-request";
import { isNullish } from "@lib/app.helpers";
import { HttpMethod } from "@lib/http.helpers";
import {
  flatMapPaginatedData,
  getNextPageParam,
} from "@lib/pagination.helpers";

export const useCareerMatches = ({
  enabled,
  limit,
  relatedCareersFirst,
  sort,
} = {}) => {
  const queryFn = useApiRequest({ method: HttpMethod.Get });

  return useInfiniteQuery({
    queryKey: ["career-matches", limit, sort],
    queryFn: async ({ pageParam: { url, params } }) => {
      if (!isNullish(relatedCareersFirst)) {
        params.set("related_careers_first", relatedCareersFirst);
      }
      return queryFn({ url, params, useResponseData: false });
    },
    select: flatMapPaginatedData,
    initialPageParam: {
      url: "users/me/careers",
      params: new URLSearchParams(
        `limit=${limit ?? 5}${isNullish(sort) ? "" : `&sort=${sort}`}`,
      ),
    },
    getNextPageParam,
    enabled: enabled ?? true,
  });
};
